import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, AfterContentInit, AfterViewChecked, ElementRef, ViewChildren, Inject } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { IPager } from '../../../shared/models/pager.model';
import { Subscription, Subject, Observable } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { catchError } from 'rxjs/operators';
import * as moment from 'moment';
import * as _ from 'lodash';
import { PaymentBordereaux } from '../../../shared/models/search-payment-bordereaux.model';
import { PayChecquesService } from './pay-cheques.service';
import { IPaymentBordereaux } from '../../../shared/models/payment-bordereaux.model';
import { NotificationService } from '../../../shared/services/notification.service';
import { enumPaymentStatus, enumPaymentMethod, enumPaymentType } from '../../../shared/models/common.enum';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpEventType } from '@angular/common/http';
import { BaseComponentComponent } from '../../base-component/base-component.component';
import { SecurityService } from '../../../shared/services/security.service';



@Component({
  selector: 'app-pay-cheques',
  templateUrl: './pay-cheques.component.html',
  styleUrls: ['./pay-cheques.component.css']
})

export class PayChequesComponent extends BaseComponentComponent implements OnInit {
  @ViewChild(DataTableDirective)
  private datatableElement: DataTableDirective;
  @ViewChild('payChecquesTable') payChequesTable: ElementRef;

  public paginationInfo: IPager;
  public authenticated: boolean = false;
  public authSubscription: Subscription;
  public errorReceived: boolean;
  public dtTrigger: Subject<any>;
  isGridLoaded: boolean = false;
  public searchPayChequeVM: PaymentBordereaux = new PaymentBordereaux();

  public searchPayChequeResult: IPaymentBordereaux[];
  public dtOptions: any = {};
  modalRef: NgbModalRef;
  dropdownList = [];
  isSelectAllChecked: boolean;
  loggedInUserPaymentAuthority: number;
  loggedInUserId: number;
  dropdownSettings = {};

  displayeDataList = [];
  displayedColumns: any[] = [
    { isAlwaysVisible: true, title: '<input type="checkbox" id="selectAll"/>', data: 'isSelected', visible: true },
    { isAlwaysVisible: true, title: 'Payment ID', data: 'paymentID', visible: true },
    { isAlwaysVisible: true, title: 'Linked Documents', data: 'paymentLinkedDocuments', visible: true },
    { isAlwaysVisible: true, title: 'MMI Claim Reference', data: 'claimNumber', visible: true },
    { isAlwaysVisible: true, title: 'Payee Name', data: 'payeeName', visible: true },
    { isAlwaysVisible: true, title: 'Policyholder Name', data: 'policyHolder', visible: true },
    { isAlwaysVisible: true, title: 'Payment Code', data: 'paymentCode', visible: true },
    { isAlwaysVisible: true, title: 'Cheque No.', data: 'chequeNumber', visible: true },
    { isAlwaysVisible: true, title: 'Payment Amount', data: 'paymentAmount', visible: true, render: $.fn.dataTable.render.number(',', '.', 2, '£') },
    { isAlwaysVisible: true, title: 'Payee/Invoice Ref.', data: 'invoiceRef', visible: true },
    { isAlwaysVisible: true, title: 'Approved By (Stage 1)', data: 'approvedByStage1', visible: true },
    { isAlwaysVisible: true, title: 'Approved Date (Stage 1)', data: 'approvedDateStage1', type: 'date', visible: true, render: function (data) { return data == null ? "" : moment(data).format('DD/MM/YYYY') } },
    { isAlwaysVisible: false, title: "overrideFlag", data: "isOverWritten", visible: false },
    { isAlwaysVisible: false, title: "overridePayeeNameFlag", data: "isPayeeNameOverWritten", visible: false }
  ];


  selectedItems = [];



  constructor(public payChecquesService: PayChecquesService, public notificationService: NotificationService,
    private modalService: NgbModal, securityService: SecurityService) {
    super(securityService, 1150);
    this.dtTrigger = new Subject();
  }

  ngOnInit(): void {
    if (this.isReadOnlyMode) {
      this.displayedColumns[0].visible = false;
    }
    this.loggedInUserPaymentAuthority = (this.securityService.getUserData().financeApprovalAuthority != null) ? this.securityService.getUserData().financeApprovalAuthority : 0;
    this.loggedInUserId = this.securityService.getUserData().id;
    this.initialiseDataTable();
    this.isSelectAllChecked = false;
    this.searchPayChequeVM;
    this.refreshGrid();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'data',
      textField: 'title',
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      showSelectedItemsAtTop: false,
      closeDropDownOnSelection: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All'
    };

    this.columnsForMultiSelect().forEach(a => {
      if (a.data != "isSelected") {
        this.displayeDataList.push(a);
      }
    });


    this.columnsForMultiSelect().forEach(a => {
      if (a.data != "isSelected") {
        this.selectedItems.push(a);
      }
    });

  }
  initialiseDataTable(): void {
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      columns: this.displayedColumns,
      //fixedColumns: {
      //  leftColumns: 1,
      //  rightColumns: 1
      //},
      scrollY: '50vh',
      scrollX: true,
      //scrollCollapse: true,
      "initComplete": function (settings, json) {
        $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
      },
      serverSide: true,
      processing: true,
      searching: false,
      // Declare the use of the extension in the dom parameter
      dom: 'Blfrtip',
      // Configure the buttons
      buttons: [
        {
          extend: 'excelHtml5',
          text: '<i class="fa fa-file-excel fa-lg"></i>',
          titleAttr: 'Excel',
          tag: '',
          action: this.newExportAction,
          messageTop: "Pay Cheques Payment PaymentBordereaux Result",
          title: " Pay Cheques Payment PaymentBordereaux",
          filename: function () { return "PayChequesPaymentBordereaux" + Math.random(); },
          exportOptions: {
            columns: [1, 3, 4, 5, 6, 7, 8, 9]
          }
        }
      ],
      select: {
        style: 'multi'
      },
      columnDefs: [{
        orderable: false,
        className: 'select-checkbox',
        targets: 0,
        //render: function (data, type, full, meta) {
        //  return '<span>&nbsp;</span>';
        //},

        render: function (data, type, full, meta: any) {
          //debugger;
          var html = "";//'<input type="checkbox" class="select-checkbox">';
          if (full.approvedByIdStage1 != that.loggedInUserId && full.createdBy != that.loggedInUserId) {
            meta.settings.aoColumns[0].sClass = 'select-checkbox';
          }
          else {
            meta.settings.aoColumns[0].sClass = '';
          }
          return html;
        }
      },
      {
        targets: 2,
        render: function (data, type, full, meta: any) {
          return that.bindPaymentLinkedDocuments(data);
        }
        },
        {
          targets: 3,
          render: function (data, type, full, meta: any) {
            return that.bindMMiClaimRefrence(full);
          }
        },
      ],
      headerCallback: function (thead, data, start, end, display) {
        var selectAllCheckBox = $('#selectAll');
        selectAllCheckBox.click(function () { that.selectAll(this) });
      },
      rowCallback: function (nRow, aData, iDisplayIndex) {
        if (aData.isPayeeNameOverWritten || aData.isOverWritten) {
          $('td', nRow).each(function () {
            $(this).html('<b>' + $(this).html() + '</b>');
          });
        }
        return nRow;

      },
      ajax: (dataTablesParameters: any, callback) => {
        var self = this;
        this.searchPayChequeVM.sortBy = dataTablesParameters.columns[dataTablesParameters.order[0].column].data;
        this.searchPayChequeVM.sortOrder = dataTablesParameters.order[0].dir;
        this.searchPayChequeVM.pageIndex = dataTablesParameters.start > 0 ? parseInt(dataTablesParameters.start) / parseInt(dataTablesParameters.length) : 0;
        this.searchPayChequeVM.pageSize = dataTablesParameters.length;
        this.searchPayChequeVM.paymentStatus = enumPaymentStatus.Verified.toString();
        this.searchPayChequeVM.paymentMethod = enumPaymentMethod.Cheque.toString();
        this.searchPayChequeVM.paymentType = enumPaymentType.SchemePaymentByMMI.toString();
        this.getData(this.searchPayChequeVM).then(resp => {

          callback({
            page: that.paginationInfo.actualPage,
            pages: that.paginationInfo.totalPages,
            recordsTotal: that.paginationInfo.totalItems,
            recordsFiltered: that.paginationInfo.totalItems,
            data: that.searchPayChequeResult
          });
          if (!this.isReadOnlyMode) {
            that.selectGridRows();
          }
          var dataTable: any = this.datatableElement;
          dataTable.dt.on('user-select', (e, dt, type, cell, originalEvent, event) => {
            if (dt.rows(cell.index()["row"]).data()[0].approvedByIdStage1 == this.loggedInUserId || this.isReadOnlyMode || dt.rows(cell.index()["row"]).data()[0].createdBy == that.loggedInUserId)
              return false;
          });
        });
      }
    };
  }

  getData(paymentBordereauxModel: PaymentBordereaux): Promise<any> {

    this.errorReceived = false;
    var claimsData: any;
    var promise = new Promise((resolve, reject) => {
      this.payChecquesService.searchPayChequePayments(paymentBordereauxModel)

        .pipe(catchError((err) => this.handleError(err)))
        .subscribe(res => {

          this.searchPayChequeResult = res.serachPaymentBordereauxResultItems;
          this.paginationInfo = res.paginationInfo;
          resolve();
        });
    });
    return promise;
  }

  private handleError(error: any) {
    this.errorReceived = true;
    return Observable.throw(error);
  }

  selectAll(data) {
    this.isSelectAllChecked = data.checked;
    this.selectGridRows();
  }

  selectGridRows() {

    var dataTable: any = this.datatableElement;
    var checked = this.isSelectAllChecked;
    let handlerId = this.loggedInUserId;
    dataTable.dt.rows().every(function (rowIdx, tableLoop, rowLoop) {
      var rowData = this.data();
      if (rowData.approvedByIdStage1 != handlerId && rowData.createdBy != handlerId) {

        if (checked) {
          this.rows(rowIdx).select();
        }
        else {
          this.rows(rowIdx).deselect();
        }
      }
    });
  }


  ngAfterViewChecked(): void {
    if (!this.isGridLoaded) {
      this.refreshGrid();
    }
  }

  onViewHideItemSelect(item: any) {
    let c = _.filter(this.displayedColumns, function (o) { return o.data == item.data; });
    c[0].visible = true;

    this.refreshGrid();
  }

  onViewHideItemDeSelect(item: any) {
    let c = _.filter(this.displayedColumns, function (o) { return o.data == item.data; });
    c[0].visible = false;

    this.refreshGrid();
  }

  onViewHideSelectAll() {
    this.displayedColumns.forEach(a => {
      if (a.data != "isSelected") {
        a.isAlwaysVisible ? a.visible = true : a.visible = false;
      }
    });

    this.refreshGrid()
  }

  onViewHideDeSelectAll() {
    this.displayedColumns.forEach(a => {
      if (a.data != "isSelected") {
        a.visible = false;
      }
    });

    this.refreshGrid();
  }

  //searchBordereaux(): void {
  //  if (this.datatableElement.dtInstance) {
  //    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //      dtInstance.destroy();
  //      this.dtTrigger.next();
  //    });
  //  }
  //  else {
  //    this.dtTrigger.next();
  //  }

  //}

  refreshGrid() {
    if (this.payChequesTable) {
      if (this.datatableElement && this.datatableElement.dtInstance) {
        this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
        });
      }
      else {
        this.dtTrigger.next();
      }
      this.isGridLoaded = true;


    }
  }

  columnsForMultiSelect() {
    let c = _.filter(this.displayedColumns, function (o) { return o.isAlwaysVisible == true; });
    return c;
  }

  onApprovePayChequePayments() {
    this.modalRef.close();

    var dataTable: any = this.datatableElement;
    var selectedItems: any[] = dataTable.dt.rows('.selected').data();
    if (!this.checkApprovalAuthorityValidation()) {
      this.notificationService.printWarningMessage("This payment exceeds your Approval Stage 1 (Claims) Authority. Please refer to a colleague with a sufficient Approval Stage 1 (Claims) Authority to approve this payment.");
      return;
    }
    var selectedPaymentIds: number[] = _.map(selectedItems, i => i.paymentID);

    if (selectedPaymentIds.length === 0) {
      this.notificationService.printWarningMessage('Please select payment(s) to Approve');
      return;
    }

    this.payChecquesService.approvePayChequePayments(selectedPaymentIds, this.loggedInUserId).subscribe(res => {
      switch (res.type) {
        case HttpEventType.Response:
          this.notificationService.printSuccessMessage('Selected payment(s) approved successfully');
          this.refreshGrid();
          const downloadedFile = new Blob([res.body], { type: res.body.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = this.getFileName(res.headers.get('Content-Disposition'));
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
      }

    },
      error => {
        this.notificationService.printErrorMessage(error.message);
      }
    )
  }

  getFileName(disposition: string): string {
    var filename: any;
    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    var matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }

    return filename;
  }

  OnRejectPayChequePayments() {
    this.modalRef.close();
    var dataTable: any = this.datatableElement;
    var selectedItems: any[] = dataTable.dt.rows('.selected').data();
    if (!this.checkApprovalAuthorityValidation()) {
      this.notificationService.printWarningMessage("This payment exceeds your Approval Stage 1 (Claims) Authority. Please refer to a colleague with a sufficient Approval Stage 1 (Claims) Authority to approve this payment.");
      return;
    }
    var selectedPaymentIds: number[] = _.map(selectedItems, i => i.paymentID);
    if (selectedPaymentIds.length === 0) {
      this.notificationService.printWarningMessage('Please select payment(s) to Reject');
      return;
    }
    this.payChecquesService.rejectPayChequePayments(selectedPaymentIds).subscribe(res => {
      this.notificationService.printSuccessMessage('Selected payment(s) rejected successfully');
      this.refreshGrid();
    },
      error => {
        this.notificationService.printErrorMessage(error.message);
      }
    )
  }

  checkApprovalAuthorityValidation(): boolean {
    let isValidAuthority = true;
    let loggedInUserAuthority = this.loggedInUserPaymentAuthority;
    var dataTable: any = this.datatableElement;
    dataTable.dt.rows('.selected').every(function (rowIdx, tableLoop, rowLoop) {
      var rowData = this.data();
      if (rowData.paymentAmount > loggedInUserAuthority) {
        this.node().className = 'highlightData';
        isValidAuthority = false;
      }
    });
    return isValidAuthority;
  }

  openDialog(content) {
    var dataTable: any = this.datatableElement;
    var selectedrows: any[] = dataTable.dt.rows('.selected').data();
    var selectedPaymentIds: number[] = _.map(selectedrows, i => i.paymentID);
    if (selectedPaymentIds.length === 0) {
      this.notificationService.printWarningMessage('No payment(s) selected for action');
      return;
    }

    this.modalRef = this.modalService.open(content);
  }

  public newExportAction(e, dt, button, config) {
    var self = this;
    var oldStart = dt.settings()[0]._iDisplayStart;
    console.log("buttons");
    //console.log($.fn.dataTable.ext.buttons);
    dt.one('preXhr', function (e, s, data) {
      // Just this once, load all data from the server...
      data.start = 0;
      data.length = 500;

      dt.one('preDraw', function (e, settings) {
        // Call the original action function
        oldExportAction(self, e, dt, button, config);

        dt.one('preXhr', function (e, s, data) {
          // DataTables thinks the first item displayed is index 0, but we're not drawing that.
          // Set the property to what it was before exporting.
          settings._iDisplayStart = oldStart;
          data.start = oldStart;
        });

        // Reload the grid with the original page. Otherwise, API functions like table.cell(this) don't work properly.
        setTimeout(dt.ajax.reload, 0);

        // Prevent rendering of the full data to the DOM
        return false;
      });
    });

    // Requery the server with the new one-time export settings
    dt.ajax.reload();

    function oldExportAction(self, e, dt, button, config) {
      if (button[0].className.indexOf('buttons-excel') >= 0) {
        //this.datatableElement.dtInstance.
        var buttons: any = ($.fn.dataTable.ext as any).buttons;
        if (buttons.excelHtml5.available(dt, config)) {
          buttons.excelHtml5.action.call(self, e, dt, button, config);
        }
        else {
          buttons.excelFlash.action.call(self, e, dt, button, config);
        }
      } else if (button[0].className.indexOf('buttons-print') >= 0) {
        buttons.print.action(e, dt, button, config);
      }
    }
  };

  public oldExportAction(self, e, dt, button, config) {
    if (button[0].className.indexOf('buttons-excel') >= 0) {
      //this.datatableElement.dtInstance.
      var buttons: any = ($.fn.dataTable.ext as any).buttons;
      if (buttons.excelHtml5.available(dt, config)) {
        buttons.excelHtml5.action.call(self, e, dt, button, config);
      }
      else {
        buttons.excelFlash.action.call(self, e, dt, button, config);
      }
    } else if (button[0].className.indexOf('buttons-print') >= 0) {
      buttons.print.action(e, dt, button, config);
    }
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  bindPaymentLinkedDocuments(linkDocs) {
    let result = "";
    for (var i = 0; i < linkDocs.length; i++) {
      result += "<a href='" + linkDocs[i].linkedDocumentUrl + "' target = '_blank' > " + linkDocs[i].linkedDocumentName + " </a></br>";
    }
    return "<span>" + result + "</span>";
  }

  bindMMiClaimRefrence(full) {
    let result = "";
    result += "<a href='" + "claims/" + full.policyId + "/" + full.claimId + "/" + "claimdetail" + "' target = '_blank' > " + full.claimNumber + " </a></br>";
    return "<span>" + result + "</span>";
  }
}
